import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const DocumentsWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default DocumentsWrapper